(function () {
  var data = null;
  var loading = null;
  var fixing = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function load() {
    loading = fetch(root() + 'cart?view=backorder-note', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        data = JSON.parse(text.trim());
      })
      .catch(function () {
        data = null;
      })
      .then(function () {
        loading = null;
      });
    return loading;
  }

  function needed(variantId, quantity) {
    if (!data || !data.label || !data.value) return null;
    var variant = data.variants[String(variantId)];
    if (!variant) return null;
    return variant.c === true && variant.a === true && quantity > variant.q;
  }

  function inCart(variantId) {
    return (data.lines || []).some(function (line) {
      return String(line.variant) === String(variantId);
    });
  }

  function withNote(properties, wanted) {
    var merged = {};
    Object.keys(properties || {}).forEach(function (name) {
      if (/^\d+$/.test(name)) return;
      merged[name] = properties[name];
    });
    if (wanted) merged[data.label] = data.value;
    else delete merged[data.label];
    return merged;
  }

  function applyToFormData(body, prefix, wanted) {
    var key = prefix ? prefix + '[properties][' + data.label + ']' : 'properties[' + data.label + ']';
    var present = body.get(key) !== null;
    if (wanted && !present) body.append(key, data.value);
    if (!wanted && present) body.delete(key);
  }

  function fixAddFormData(body) {
    if (body.get('id') !== null) {
      var wanted = needed(body.get('id'), parseInt(body.get('quantity') || '1', 10));
      if (wanted !== null && !inCart(body.get('id'))) applyToFormData(body, '', wanted);
    }
    var index = 0;
    while (body.get('items[' + index + '][id]') !== null) {
      var id = body.get('items[' + index + '][id]');
      var quantity = parseInt(body.get('items[' + index + '][quantity]') || '1', 10);
      var itemWanted = needed(id, quantity);
      if (itemWanted !== null && !inCart(id)) applyToFormData(body, 'items[' + index + ']', itemWanted);
      index += 1;
    }
  }

  function fixAddPayload(payload) {
    var changed = false;
    var lines = Array.isArray(payload.items) ? payload.items : [payload];
    lines.forEach(function (line) {
      if (!line || line.id === undefined || line.id === null) return;
      var wanted = needed(line.id, line.quantity || 1);
      if (wanted === null || inCart(line.id)) return;
      line.properties = withNote(line.properties, wanted);
      changed = true;
    });
    return changed;
  }

  function findLine(identifier, byIndex) {
    var lines = data.lines || [];
    if (byIndex) return lines[parseInt(identifier, 10) - 1] || null;
    for (var i = 0; i < lines.length; i += 1) {
      if (String(lines[i].key) === String(identifier)) return lines[i];
    }
    return lines[parseInt(identifier, 10) - 1] || null;
  }

  function fixChangePayload(payload) {
    if (payload.quantity === undefined) return false;
    var line = findLine(payload.line !== undefined ? payload.line : payload.id, payload.line !== undefined);
    if (!line) return false;
    var wanted = needed(line.variant, payload.quantity);
    if (wanted === null) return false;
    payload.properties = withNote(line.properties, wanted);
    return true;
  }

  function fixChangeFormData(body) {
    if (body.get('quantity') === null) return;
    var byIndex = body.get('line') !== null;
    var line = findLine(byIndex ? body.get('line') : body.get('id'), byIndex);
    if (!line) return;
    var wanted = needed(line.variant, parseInt(body.get('quantity'), 10));
    if (wanted === null) return;
    var merged = withNote(line.properties, wanted);
    Object.keys(line.properties || {}).forEach(function (name) {
      body.delete('properties[' + name + ']');
    });
    Object.keys(merged).forEach(function (name) {
      body.append('properties[' + name + ']', merged[name]);
    });
  }

  function fixBody(init, isAdd) {
    if (!init || !init.body || !data) return;
    if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
      if (isAdd) fixAddFormData(init.body);
      else fixChangeFormData(init.body);
      return;
    }
    if (typeof URLSearchParams !== 'undefined' && init.body instanceof URLSearchParams) {
      var asForm = new FormData();
      init.body.forEach(function (value, name) {
        asForm.append(name, value);
      });
      if (isAdd) fixAddFormData(asForm);
      else fixChangeFormData(asForm);
      var rebuilt = new URLSearchParams();
      asForm.forEach(function (value, name) {
        rebuilt.append(name, value);
      });
      init.body = rebuilt;
      return;
    }
    if (typeof init.body === 'string') {
      try {
        var payload = JSON.parse(init.body);
        var changed = isAdd ? fixAddPayload(payload) : fixChangePayload(payload);
        if (changed) init.body = JSON.stringify(payload);
        return;
      } catch (error) {}
      try {
        var params = new URLSearchParams(init.body);
        var form = new FormData();
        params.forEach(function (value, name) {
          form.append(name, value);
        });
        if (isAdd) fixAddFormData(form);
        else fixChangeFormData(form);
        var rebuiltParams = new URLSearchParams();
        form.forEach(function (value, name) {
          rebuiltParams.append(name, value);
        });
        init.body = rebuiltParams.toString();
      } catch (error) {}
    }
  }

  function afterCartCall() {
    load().then(function () {
      return reconcile(0);
    });
  }

  function rebuild(line) {
    var properties = withNote(line.properties, needed(line.variant, line.qty));
    var headers = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    return fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({ id: line.key, quantity: 0 }),
    }).then(function () {
      return fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ items: [{ id: line.variant, quantity: line.qty, properties: properties }] }),
      });
    });
  }

  function reconcile(pass) {
    if (!data || fixing || pass > 2) return Promise.resolve();
    var broken = (data.lines || []).filter(function (line) {
      var wanted = needed(line.variant, line.qty);
      if (wanted === null) return false;
      var present = Object.prototype.hasOwnProperty.call(line.properties || {}, data.label);
      return wanted !== present;
    });
    if (!broken.length) return Promise.resolve();
    fixing = true;
    return broken
      .reduce(function (chain, line) {
        return chain.then(function () {
          return rebuild(line);
        });
      }, Promise.resolve())
      .catch(function () {})
      .then(function () {
        fixing = false;
        return load();
      })
      .then(function () {
        return reconcile(pass + 1);
      });
  }

  var originalFetch = window.fetch;
  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = url.indexOf('/cart/add') > -1;
      var isChange = url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1;
      if ((!isAdd && !isChange) || fixing) return originalFetch.apply(this, arguments);

      var self = this;
      var args = arguments;

      function send() {
        fixBody(init, isAdd);
        return originalFetch.apply(self, args).then(function (response) {
          afterCartCall();
          return response;
        });
      }

      if (!data) return (loading || load()).then(send);
      return send();
    };
  }

  if (typeof XMLHttpRequest !== 'undefined') {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.cartDelayedUrl = typeof url === 'string' ? url : '';
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      var url = this.cartDelayedUrl || '';
      var isAdd = url.indexOf('/cart/add') > -1;
      var isChange = url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1;
      if ((isAdd || isChange) && !fixing) {
        if (data && body) {
          var init = { body: body };
          fixBody(init, isAdd);
          body = init.body;
        }
        this.addEventListener('load', afterCartCall);
      }
      return originalSend.call(this, body);
    };
  }

  window.cartDelayedNote = {
    stan: function () {
      return data;
    },
    przelicz: function () {
      return load().then(function () {
        return reconcile(0);
      });
    },
  };

  function start() {
    load().then(function () {
      return reconcile(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
